<div class="input-group">
    <input
        wdxInputText
        currencyMask
        [options]="decimalMaskNumberConfigOverride"
        [disabled]="disabled"
        [attr.data-cy]="cySelector"
        [ngModel]="timeValue"
        (ngModelChange)="timeValueChange($event)"
    />
    <ng-select
        [(ngModel)]="timeUnit"
        (ngModelChange)="timeUnitChange()"
        [readonly]="timeUnits.length === 1 || disabled"
        [clearable]="false"
        [items]="timeUnits"
    />
</div>
